import "./WorkBrand.css";
import scaleupnepal from "../../Images/Works/Scaleupnepal.png";
import scaleupacademy from "../../Images/Works/Scaleupacademy.png";
import hello from "../../Images/Works/Hello.png";
import pokharainternet from "../../Images/Works/PokharaInternet.png";
import pch from "../../Images/Works/PCH.png";

const WorkBrand = () => {
    return (
        <>
            <div className="workBrandSec">
                <div className="works makeAnimation">
                    <img src={scaleupnepal} alt="" />
                    <img src={scaleupacademy} alt="" />
                    <img src={pokharainternet} alt="" />
                    <img src={hello} alt="" />
                    <img src={pch} alt="" />
                    <img src={scaleupnepal} alt="" />
                    <img src={scaleupacademy} alt="" />
                    <img src={pokharainternet} alt="" />
                    <img src={hello} alt="" />
                    <img src={pch} alt="" />
                </div>
            </div>
        </>
    )
}
export default WorkBrand;